
import { defineComponent } from 'vue';
import TeethRadarChart from "@/components/TeethRadarChart.vue";
import ShishikiComponent from "@/components/ShishikiComponent.vue";
import axios from "axios";
import TeethExam from "@/components/TeethExam.vue";
import TeethExamPackageDto from "@/dto/TeethExamPackageDto";
import {KenshinDto} from "@/dto/KenshinDto";
import FormatUtils from "@/utils/FormatUtils";
import SogoHantei, {SogoHanteiEnum} from "@/enums/SogoHantei";
import KenshinService from "@/service/KenshinService";
import CloneUtils from "@/utils/CloneUtils";
import {FontAwesomeIcon as Fa} from "@fortawesome/vue-fontawesome";
import LoadingUtils from "@/utils/LoadingUtils";
import ShishikiComponent2 from "@/components/ShishikiComponent2.vue";
//import Chart from 'chart.js/auto';
export default defineComponent({
  name: 'CurrentView',
  components: {TeethExam, ShishikiComponent, TeethRadarChart},
  async created() {
    LoadingUtils.start()
    //FormatUtils.format('')
    this.axios.get('/getConfig', {params: {keys: ['iro_kbn_1','iro_kbn_2','iro_kbn_3','iro_kbn_4']}}).then(res => {
      this.configs = res.data as { [key: string]: string }
      //健診一覧の取得
      this.axios.get('/getKenshinList').then(res=>{
        this.kenshinList = res.data as KenshinDto[]
        for(const num of ['1','2','3','4']){
          this.iroKbnMap.set(num, this.configs['iro_kbn_'+num])
        }
        this.settleCurrent(0)
      }).finally(()=>{
        LoadingUtils.end()
      })
    })
  },
  data(){
    return {
      showShishiDoc: false,
      showNoroDoc: false,
      showCpitnDoc: false,
      tns: [8,7,6,5,4,3,2,1,1,2,3,4,5,6,7,8] as number[],
      upper: ['ur8','ur7','ur6','ur5','ur4','ur3','ur2','ur1','ul1','ul2','ul3','ul4','ul5','ul6','ul7','ul8'] as string[],
      lower: ['dr8','dr7','dr6','dr5','dr4','dr3','dr2','dr1','dl1','dl2','dl3','dl4','dl5','dl6','dl7','dl8'] as string[],
      configs: {} as { [key: string]: string },
      iroKbnMap: new Map<string, string>(),
      kenshinList: [] as KenshinDto[],
      currentKenshin: {} as KenshinDto,
      prevKenshin: {} as KenshinDto,
      kenshinService: {} as KenshinService,
      prevKenshinService: {} as KenshinService,
      teethInfo:{} as TeethExamPackageDto,
      showG: true,
      tabIndex: 0,
      ready: false
    }
  },
  methods: {
    getSogoHanteiColor(sogoHantei: string|null): string{
      const senum = SogoHantei.getEnum('' + sogoHantei) as SogoHanteiEnum
      return senum?.color
    },
    changeTab(index: number){
      this.tabIndex = index
    },
    handleChange(event: Event) {
      //const selectedValue = (event.target as HTMLSelectElement).value;
      this.settleCurrent((event.target as HTMLSelectElement).selectedIndex)
    },
    settleCurrent(index: number){
      this.ready = false
      try{
        this.currentKenshin = {} as KenshinDto
        this.prevKenshin = {} as KenshinDto
        if(this.kenshinList.length>0){
          this.currentKenshin = CloneUtils.clone(this.kenshinList[index])
          if(this.kenshinList[index+1]){
            this.prevKenshin = CloneUtils.clone(this.kenshinList[index+1])
          }else{
            this.prevKenshin = {} as KenshinDto
          }
        }else{
          this.currentKenshin = {} as KenshinDto
        }
        this.currentKenshin.shishikiUpperColor = []
        this.currentKenshin.shishikiLowerColor = []
        this.currentKenshin.teethUpperColor = []
        this.currentKenshin.teethLowerColor = []
        this.prevKenshin.shishikiUpperColor = []
        this.prevKenshin.shishikiLowerColor = []
        this.prevKenshin.teethUpperColor = []
        this.prevKenshin.teethLowerColor = []
        //今回
        this.kenshinService = new KenshinService(this.iroKbnMap, this.currentKenshin)
        for(let i=0; i<this.upper.length; i++){
          const eachUpper = [] as string[]
          const eachLower = [] as string[]
          this.currentKenshin.shishikiUpperColor.push(eachUpper)
          this.currentKenshin.shishikiLowerColor.push(eachLower)
          for(let j=0; j<3; j++){
            eachUpper.push(this.kenshinService.getShishikiColor(true, i, j))
            eachLower.push(this.kenshinService.getShishikiColor(false, i, j))
          }
          this.currentKenshin.teethUpperColor.push(this.kenshinService.getTeethColor(true, i))
          this.currentKenshin.teethLowerColor.push(this.kenshinService.getTeethColor(false, i))
        }
        this.teethInfo = {

          ur8:{color: this.currentKenshin.teethUpperColor[0]},
          ur7:{color: this.currentKenshin.teethUpperColor[1]},
          ur6:{color: this.currentKenshin.teethUpperColor[2]},
          ur5:{color: this.currentKenshin.teethUpperColor[3]},
          ur4:{color: this.currentKenshin.teethUpperColor[4]},
          ur3:{color: this.currentKenshin.teethUpperColor[5]},
          ur2:{color: this.currentKenshin.teethUpperColor[6]},
          ur1:{color: this.currentKenshin.teethUpperColor[7]},
          ul1:{color: this.currentKenshin.teethUpperColor[8]},
          ul2:{color: this.currentKenshin.teethUpperColor[9]},
          ul3:{color: this.currentKenshin.teethUpperColor[10]},
          ul4:{color: this.currentKenshin.teethUpperColor[11]},
          ul5:{color: this.currentKenshin.teethUpperColor[12]},
          ul6:{color: this.currentKenshin.teethUpperColor[13]},
          ul7:{color: this.currentKenshin.teethUpperColor[14]},
          ul8:{color: this.currentKenshin.teethUpperColor[15]},
          br8:{color: this.currentKenshin.teethLowerColor[0]},
          br7:{color: this.currentKenshin.teethLowerColor[1]},
          br6:{color: this.currentKenshin.teethLowerColor[2]},
          br5:{color: this.currentKenshin.teethLowerColor[3]},
          br4:{color: this.currentKenshin.teethLowerColor[4]},
          br3:{color: this.currentKenshin.teethLowerColor[5]},
          br2:{color: this.currentKenshin.teethLowerColor[6]},
          br1:{color: this.currentKenshin.teethLowerColor[7]},
          bl1:{color: this.currentKenshin.teethLowerColor[8]},
          bl2:{color: this.currentKenshin.teethLowerColor[9]},
          bl3:{color: this.currentKenshin.teethLowerColor[10]},
          bl4:{color: this.currentKenshin.teethLowerColor[11]},
          bl5:{color: this.currentKenshin.teethLowerColor[12]},
          bl6:{color: this.currentKenshin.teethLowerColor[13]},
          bl7:{color: this.currentKenshin.teethLowerColor[14]},
          bl8:{color: this.currentKenshin.teethLowerColor[15]}
        } as TeethExamPackageDto
        //前回
        if(this.existsPrev){
          this.prevKenshinService = new KenshinService(this.iroKbnMap, this.prevKenshin)
          for(let i=0; i<this.upper.length; i++){
            const eachUpper = [] as string[]
            const eachLower = [] as string[]
            this.prevKenshin.shishikiUpperColor.push(eachUpper)
            this.prevKenshin.shishikiLowerColor.push(eachLower)
            for(let j=0; j<3; j++){
              eachUpper.push(this.prevKenshinService.getShishikiColor(true, i, j))
              eachLower.push(this.prevKenshinService.getShishikiColor(false, i, j))
            }
            this.prevKenshin.teethUpperColor.push(this.prevKenshinService.getTeethColor(true, i))
            this.prevKenshin.teethLowerColor.push(this.prevKenshinService.getTeethColor(false, i))
          }
        }
      }finally {
        this.ready = true
      }
    }
  },
  computed: {
    FU(){
      return FormatUtils
    },
    SogoHantei(){
      return SogoHantei
    },
    existsPrev(){
      return !!(this as any).prevKenshin.kenshinDate
    }
  }
});
